


<template lang="jade">

	div.posters(
		v-if="$route.name !== 'trailer'"
	)

		img.poster(
			v-for="(film, index) in films"
			:key="index"
			v-if="$route.params.filmID === film.slug"
			:id="film.slug"
			:src="film.acf.poster"
		)

		div.posters-preload
			img(
				v-for="(film, index) in films"
				:key="index"
				:src="film.acf.poster"
			)



</template>



<script>



	const $cmp = {
		name : 'posters',
		components : {}
	}



	$cmp.data = function() {
		return {}
	}



	$cmp.computed = {}

	$cmp.computed.films = function() {

		let $this = this
		let $pages = $this.$store.pages

		if ($pages.films) {
			return $pages.films.children
		} else {
			return $pages
		}

	}



	$cmp.mounted = function() {
		var $this = this
		console.log($this.$route)
	}



	$cmp.methods = {}



	export default $cmp



</script>



<style lang="stylus" scoped>

	.posters
		position absolute
		top 0px
		left 0px
		right 0px
		bottom 0px
		z-index 2

		@media(max-width 1023px)
			display none

	.poster
		position absolute
		min-height 100%
		min-width 100%
		top 50%
		left 50%
		transform translate(-50%,-50%)

	.posters-preload
		display none

</style>



// WEBPACK FOOTER //
// src/components/home/posters.vue